import { Option } from '@sapphire/result';
import {
  ADVANCED_FILTER_TYPE,
  ComputeFeasibilityParams,
  Survey,
  surveyToMetadataForm,
} from '@ps/survey-utils';

export interface FeasibilityUser {
  readonly id: number;
  readonly email: string;
  readonly companyId: number;
}

/**
 * Rebuilds the feasibility request from a persisted survey — the manage-survey
 * equivalent of the creation flow's `computeFeasibilityParams`, which sources the
 * same fields from the live audience form. Grouping only applies to an Exclude
 * survey with exclusions enabled and at least one group.
 */
export function toFeasibilityParamsFromSurvey(
  survey: Survey,
  user: FeasibilityUser,
  supplierIds: readonly number[],
): ComputeFeasibilityParams {
  const advancedFilters = survey.advancedFeasibilityFilters;
  const isExclusion = advancedFilters.type === ADVANCED_FILTER_TYPE.EXCLUDE;

  const base: ComputeFeasibilityParams = {
    surveyId: survey.id,
    user,
    metadata: surveyToMetadataForm(survey),
    qualifications: survey.qualifications ?? [],
    quotas: survey.quotas ?? [],
    // Parity with the creation edit-load: no offer price is applied on open.
    offerPrice: Option.none,
    supplierIds,
    surveyGroupIds: [],
    isExclusion,
    groupingStatuses: [],
  };

  if (!isExclusion || !advancedFilters.excludeFromFeasibleAudience) {
    return base;
  }

  const allGroupIds = [
    ...new Set([
      ...advancedFilters.matchedGroupIds,
      ...advancedFilters.manualGroupIds,
    ]),
  ];

  if (!allGroupIds.length) {
    return base;
  }

  return {
    ...base,
    surveyGroupIds: allGroupIds,
    groupingStatuses: [...advancedFilters.respondentStatuses],
  };
}
